import { render, staticRenderFns } from "./PackageSchedule.vue?vue&type=template&id=f2b85824&scoped=true"
import script from "./PackageSchedule.vue?vue&type=script&lang=js"
export * from "./PackageSchedule.vue?vue&type=script&lang=js"
import style0 from "./PackageSchedule.vue?vue&type=style&index=0&id=f2b85824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b85824",
  null
  
)

export default component.exports